import { useDebouncedValue } from '@openx/utils/hooks/useDebouncedValue';
import { useFormContext, useWatch } from 'react-hook-form';
import { PREVIEW_DEBOUNCE_MS } from '../../components/preview/constants';
import { VideoThumbnail as VideoThumbnailPreview } from '../../components/preview/VideoThumbnail';
import type { VideoCreativeFormData } from '../validation/videoCreative';

export const VideoThumbnail = () => {
  const { control } = useFormContext<VideoCreativeFormData>();
  const observableMarkupPayload = useWatch({ control, name: 'markup_payload' });
  const debouncedMarkup = useDebouncedValue(observableMarkupPayload, PREVIEW_DEBOUNCE_MS);

  return <VideoThumbnailPreview markupPayload={debouncedMarkup} />;
};
